const getAbsoluteNodeOffset = (elem, root = null) => {
  const result = {
    x: 0,
    y: 0
  };
  let currElem = elem;
  while (currElem && (!root || root.contains(currElem))) {
    result.x += currElem.offsetLeft;
    result.y += currElem.offsetTop;
    currElem = currElem.offsetParent;
  }
  return result;
};

export { getAbsoluteNodeOffset };
//# sourceMappingURL=dom.absolute-node-offset.js.map
